// extracted by mini-css-extract-plugin
export var fullWidthButton = "_se-0";